module.exports = __webpack_public_path__ + "img/coming-soon-dark.svg";